import React, { createContext, useState } from 'react';
import _ from 'lodash';

const PageContext = createContext();

const PageProvider = (props) => {
    // members tab state
    const [checked, setChecked] = useState([]);
    const [isInviteInstructorOpen, setIsInviteInstructorOpen] = useState(false);
    const [inviteInstructorInputValue, setInviteInstructorInputValue] = useState('');
    const [inviteInstructorEmails, setInviteInstructorEmails] = useState([]);
    const [isInviteInstructorLoading, setIsInviteInstructorLoading] = useState(false);
    const [isInviteStudentOpen, setIsInviteStudentOpen] = useState(false);
    const [inviteStudentAccordions, setInviteStudentAccordions] = useState({ staged: true, invited: false });
    const [csvStudents, setCSVStudents] = useState([]);
    const [inviteStudentInputValue, setInviteStudentInputValue] = useState('');
    const [inviteStudentEmails, setInviteStudentEmails] = useState([]);
    const [isInviteStudentLoading, setIsInviteStudentLoading] = useState(false);
    const [dialog, setDialog] = useState({
        open: false,
        message: '',
        description: '',
        variant: 'primary',
        actionButtonText: '',
        onAction: () => {},
    });
    const [cloningContentsDialog, setCloningContentsDialog] = useState({
        open: false,
        message: '',
        description: '',
        variant: 'primary',
        actionButtonText: '',
        onAction: () => {},
    });
    const [generatedIdList, setGeneratedIdList] = useState([]);
    const [memberFilters, setMemberFilters] = useState({
        open: false,
        sortKey: 'namea-z',
        filterKeys: [],
        searchInput: '',
    });

    const value = {
        checked,
        setChecked,
        cloningContentsDialog,
        setCloningContentsDialog,
        generatedIdList,
        setGeneratedIdList,
        isInviteInstructorOpen,
        setIsInviteInstructorOpen,
        inviteInstructorInputValue,
        setInviteInstructorInputValue,
        inviteInstructorEmails,
        setInviteInstructorEmails,
        isInviteInstructorLoading,
        setIsInviteInstructorLoading,
        isInviteStudentOpen,
        setIsInviteStudentOpen,
        inviteStudentAccordions,
        setInviteStudentAccordions,
        csvStudents,
        setCSVStudents,
        inviteStudentInputValue,
        setInviteStudentInputValue,
        inviteStudentEmails,
        setInviteStudentEmails,
        isInviteStudentLoading,
        setIsInviteStudentLoading,
        dialog,
        setDialog,
        memberFilters,
        setMemberFilters,
    };

    return <PageContext.Provider value={value} {...props} />;
};

export { PageContext };
export default PageProvider;
